import React from "react";

import { ProductTileModel } from "@api/mappers/products.mapper";

import { useThunkDispatch } from "@redux/dispatcher";
import { clear as clearMessages } from "@redux/modules/value/apiMessages/apiMessages.module";
import { clearMessages as clearVisibleMessages } from "@redux/modules/value/messages/messages.utils";

import { Messages } from "@components/General/Messages/messages.container";
import PriceBlock from "@components/Modals/AddToCartModal/Partials/priceBlock";
import { AddToCartModelRenditions } from "@components/Product/ProductImage/mappedRenditions";
import { ProductImageContainer } from "@components/Product/ProductImage/productImage.container";
import { PromotionPeriod } from "@components/Product/PromotionPeriod/promotionPeriod.container";
import { Accessories } from "@components/ShoppingCart/productCollectionBlock/cartItem/cartItemInfo/accessories/accessories.container";

import {
    ProductPromotion,
    SalesIncentive,
} from "lib/@types/service/product/shared";
import { Media } from "lib/@types/service/shared";

import { AddToCardModalFooter } from "./Partials/footer";

type Props = {
    title: string;
    medias: null | Array<Media>;
    strikethroughPrice?: number | null;
    currentPrice: number;
    salesIncentives?: Array<SalesIncentive>;
    promotions?: Array<ProductPromotion>;
    showHR: boolean;
    isBoxArticle: boolean;
    accessories: Array<ProductTileModel>;
    onClose?: React.MouseEventHandler<HTMLAnchorElement>;
    onAddAccessory: (sku: string, product: ProductTileModel) => Promise<void>;
};

const AddToCartModalComponent = ({
    title,
    medias,
    currentPrice,
    strikethroughPrice,
    showHR,
    salesIncentives,
    promotions,
    isBoxArticle,
    accessories,
    onClose,
    onAddAccessory,
}: Props) => {
    const dispatch = useThunkDispatch();

    const onModalClose: React.MouseEventHandler<HTMLAnchorElement> = e => {
        dispatch(clearMessages);
        clearVisibleMessages();
        onClose && onClose(e);
        document.body.classList.remove("modal-open");
    };

    const promotionPeriod = !isBoxArticle && promotions && salesIncentives && (
        <PromotionPeriod
            salesIncentives={salesIncentives}
            promotions={promotions}
            className={"text-right m-0"}
        />
    );

    return (
        <div>
            <Messages messageid={"add-to-cart-modal-messages"} />
            <div data-test="addToCartModal">
                <div className="row">
                    <div className="col-6 col-md-4">
                        <ProductImageContainer
                            title={title}
                            medias={medias}
                            data-test="addToCartModal-imageContainer"
                            isEcoChequesAccepted={false}
                            renditions={AddToCartModelRenditions}
                        />
                    </div>
                    <div className="col-6 d-flex flex-column align-items-end justify-content-center d-md-none">
                        <PriceBlock
                            strikethroughPrice={strikethroughPrice}
                            currentPrice={currentPrice}
                            data-test="addToCartModal-priceBlock"
                        />
                        {promotionPeriod}
                    </div>
                    <div className="col-sm-12 col-md-4">
                        <h3>{title}</h3>
                    </div>
                    <div className="d-none d-md-block col-md-4">
                        <PriceBlock
                            strikethroughPrice={strikethroughPrice}
                            currentPrice={currentPrice}
                            data-test="addToCartModal-priceBlock"
                        />
                        {promotionPeriod}
                    </div>
                </div>
                {accessories.length > 0 && (
                    <div className="row">
                        <div className="col-12 col-sm-9 offset-0 offset-sm-3 col-md-10 offset-md-2">
                            <Accessories
                                accessories={accessories}
                                onAdd={onAddAccessory}
                            />
                        </div>
                    </div>
                )}
            </div>
            <AddToCardModalFooter onModalClose={onModalClose} />
            {showHR && <hr />}
        </div>
    );
};

export default AddToCartModalComponent;
